/**
 * components/layout/RoleRoute.tsx
 *
 * Route-level guard for restricted screens: renders the page only when the
 * current user's role may open it (canAccessRoute, the rule the sidebar
 * uses); otherwise a "no access" state instead of a page whose API calls
 * would all be refused.
 */
import { canAccessRoute } from '@/lib/store';
import { useCurrentUser } from '@/lib/hooks/use-current-user';
import { ErrorState } from '@/components/ui/error-state';

export interface RoleRouteProps {
  routeKey: string;
  children: React.ReactNode;
}

export function RoleRoute({ routeKey, children }: RoleRouteProps): React.JSX.Element {
  const user = useCurrentUser();
  if (!canAccessRoute(user.role, routeKey)) {
    return <ErrorState title="No access" message="You don't have access to this page." />;
  }
  return <>{children}</>;
}
